var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"create"},[_c('grid-single-column',[_c('div',{staticClass:"create__content"},[_c('create-content')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }